<template>
  <div class="profile">
    <page-header title="My saldo">
      <div slot="sub-title">
        <fa icon="dollar-sign" />
        Saldo and credit card management
      </div>
      <div slot="controls">
        <el-button type="primary" class="fill-up-button white-button" icon="el-icon-plus" @click="showDepositDialog = true" plain>Fill up</el-button>
      </div>
    </page-header>

    <el-row :gutter="40" class="body-padding no-padding-bottom">
      <el-col :xs="12" :lg="17" class="transaction-control-header">
        <div class="second-header">
          <p class="hide-mobile">Showing - {{ transactionCountShown }} of {{ transactionCount }} <span>{{ dateRangeLabel }}</span></p>
          <transactions-filter-options
            class="hide-mobile"
            :transactionFilter="transactionFilter"
            :transactionCount="transactionCount"
            @selectDate="showTransactionFilterDialog = true" />
          <el-button
            type="primary"
            class="show-mobile"
            icon="el-icon-date"
            @click="showTransactionFilterMobileDialog = true"
            plain>
              Filter
          </el-button>
        </div>
      </el-col>
      <el-col :xs="12" :lg="7" class="saldo-container">
        <div class="saldo-value" :class="{ blink: updateSaldo }">
          <p :class="{ negative: parseInt($root.saldo.base) < 0 }">
            <span>{{ $root.currency }}</span>
            {{ $root.saldoDisplay.base }}
          </p>
          <span class="cents">.{{ $root.saldoDisplay.decimal }}</span>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="body-padding">
      <el-col :lg="17" :md="16" :sm="24">
        <el-card class="fty-padding">
          <h1 class="title justify-between">Transactions <span class="show-mobile">Showing {{ transactionCountShown }} of {{ transactionCount }} <span>{{ dateRangeLabel }}</span></span></h1>
          <transactions
            :api="$api.user($auth.user.id).transactions"
            :filter="transactionFilter"
            :newlyAddedTransaction="newTransaction"
            :limit="transactionCountShown"
            @count="setTransactionCount"
            @change="setTransactionShown" />
        </el-card>
      </el-col>
      <el-col :lg="7" :md="8" :sm="24">
        <el-card class="fty-padding">
          <auto-refill-status :status="autoRefill.status"
            @disable="disableAutoRefill"
            @manage="showAutoFillDialog = true"
            :saldo="parseInt($root.saldoDisplay.base)"
            :minimum="autoRefill.minimum"
            :amount="autoRefill.amount" />
        </el-card>
        <div class="manage-cc">
          <el-button type="primary" @click="showManageCardsDialog = true" style="width: 100%;">Manage credit cards</el-button>
        </div>
      </el-col>
    </el-row>

    <el-dialog :append-to-body="true" :visible.sync="showDepositDialog" @close="handleRefillDialogClose" :show-close="false" width="400px" top="0vh" class="z-index-TOP" custom-class="dialog-left dialog-no-padding dialog-invert dialog-blue full-width-mobile">
      <payment v-if="showDepositDialog" @complete="_refillComplete" @close="showDepositDialog = false"/>
    </el-dialog>

    <el-dialog :append-to-body="true" :visible.sync="showAutoFillDialog" @close="handleRefillDialogClose" :show-close="false" width="400px" top="0vh" class="z-index-TOP" custom-class="dialog-left dialog-no-padding dialog-invert dialog-blue full-width-mobile">
      <div v-if="showAutoFillDialog">
        <auto-refill @complete="autoRefillComplete" @close="showAutoFillDialog = false" :options="autoRefill" />
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" :visible.sync="showManageCardsDialog" :show-close="false" width="400px" top="0vh" class="z-index-TOP" custom-class="dialog-left dialog-no-padding dialog-invert dialog-blue full-width-mobile">
        <card-list v-if="showManageCardsDialog" @close="showManageCardsDialog = false" showLoading buttonTitle="Close" manage/>
    </el-dialog>

    <div class="show-mobile">
      <el-dialog :append-to-body="true" :visible.sync="showTransactionFilterMobileDialog" width="100%" custom-class="dialog-no-padding dialog-invert">
        <transactions-filter-options :transactionFilter="transactionFilter" :transactionCount="transactionCount" @selectDate="showTransactionFilterDialog = true" />
      </el-dialog>
    </div>

    <el-dialog :append-to-body="true" :visible.sync="showTransactionFilterDialog" width="400px" custom-class="dialog-no-padding dialog-invert">
      <div class="transaction-filter-dialog">
        <el-date-picker
          v-model="transactionFilter.tempRange"
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date">
        </el-date-picker>
        <el-button type="primary" @click="setTransactionFilterRange">Filter</el-button>
      </div>
    </el-dialog>

    
  </div>
</template>

<script>
import Transactions from '@/components/dashboard/transactions/Transactions'
import Payment from '@/components/dashboard/saldoAndCredit/Payment'
import AutoRefillStatus from '@/components/dashboard/saldoAndCredit/auto-refill/AutoRefillStatus'
import AutoRefill from '@/components/dashboard/saldoAndCredit/auto-refill/AutoRefill'
import CardList from './CardList'
import CreditCardsImg from '@/assets/credit-cards-payment.svg'
import TransactionsFilterOptions from './TransactionsFilterOptions'

export default {
  name: 'SaldoAndCredit',
  components: { Transactions, Payment, AutoRefillStatus, AutoRefill, CardList, TransactionsFilterOptions },
  data () {
    return {
      showTransactionFilterMobileDialog: false,
      showManageCardsDialog: false,
      showDepositDialog: false,
      showAutoFillDialog: false,
      showTransactionFilterDialog: false,
      newTransaction: null,
      transitionName: '',
      depositStep: 1,
      amount: '',
      refillComplete: false,
      updateSaldo: false,
      saldo: 0,
      autoRefill: {
        status: false,
        minimum: 500,
        amount: 1500,
        source: null
      },
      creditCardsImg: CreditCardsImg,
      transactionCountShown: 10,
      transactionCount: 0,
      transactionFilter: {
        tempRange: [],
        range: [],
        purchases: true,
        deposits: true
      }
    }
  },
  computed: {
    dateRangeLabel () {
      if (this.transactionFilter.range && this.transactionFilter.range.length === 2) {
        return '- from ' + this.transactionFilter.range[0].toDateString() + ' to ' + this.transactionFilter.range[1].toDateString()
      }

      return ''
    },
    compAmount () {
      return parseInt(this.amount.split(' ')[1])
    },
    saldoFormatted () {
      return this.saldo / 100
    }
  },
  watch: {
    depositStep (newVal, oldVal) {
      if (oldVal === 1 && newVal === 2) {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    }
  },
  methods: {
    setTransactionFilterRange () {
      this.transactionFilter.range = this.transactionFilter.tempRange
      this.showTransactionFilterDialog = false
    },
    setTransactionShown (count) {
      this.transactionCountShown = count
    },
    setTransactionCount (count) {
      this.transactionCount = count
    },
    disableAutoRefill () {
      this.$http.post(this.$api.payments.autoRefill + '?disable=true', {})
        .then(response => {
          this.autoRefill.status = false
          this.autoRefill.minimum = 0
          this.autoRefill.amount = 0
          this.autoRefill.source = null

          this.$message('Auto refill has been disabled')
        }, _ => {
          
        })
    },
    autoRefillComplete (options) {
      this.autoRefill.source = options.source
      this.autoRefill.minimum = options.minimum
      this.autoRefill.amount = options.amount
      this.autoRefill.status = true

      console.log(options)

      if (options.transaction) {
        this._refillComplete(options.transaction)
      }
    },
    _refillComplete (transaction) {
      this.refillComplete = true
      this.newTransaction = transaction      
    },
    handleRefillDialogClose () {
      this.depositStep = 1
      if (this.refillComplete) {
        this.updateSaldo = true
        this.refillComplete = false
        setTimeout(() => {
          this.$root.updateSaldo(this.newTransaction.amount)
        }, 350)
        setTimeout(() => {
          this.updateSaldo = false
        }, 700)
      }
    }
  },
  created () {
    this.$http.get(this.$api.user(this.$auth.user.id).get)
      .then(response => {
        this.$root.saldo = response.data.saldo
        this.$root.currency = response.data.currency.name
        this.autoRefill.status = response.data.autoRefillSource !== null
        this.autoRefill.minimum = response.data.autoRefillMinimum
        this.autoRefill.amount = response.data.autoRefillAmount
        this.autoRefill.source = response.data.autoRefillSource
      }, _ => {

      })
  }
}
</script>

<style lang="scss" scoped>

  .second-header {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: uppercase;

    p {
      font-size: 14px;
      color: #C0C4CC;
      margin: 0;

      span {
        color: $main;
      }
    }

    @include breakpoint (xs) {
      width: 100%;
      padding-left: 20px;
      box-sizing: border-box;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: flex-start;
    }
  }

  .negative {
    color: $red !important;
  }

  .transaction-filter-dialog {
    display: flex;
    align-items: center;

    button {
      height: 50px;
    }
  }

  .transaction-filter {
    display: flex;
    align-items: center;

    @include breakpoint (xs) {
      width: 100%;
      flex-wrap: wrap-reverse;
      justify-content: center;
    }
  }

  .saldo-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 50px;

    @include breakpoint (xs) {
      padding-right: 40px !important;
    }
  }

  .manage-cc {
    display: flex;
    align-items: center;

    img {
      width: 20px;
      height: auto;
      margin-left: 7px;
    }

    button {
      font-size: 14px !important;
    }

    @include breakpoint (xs) {
      padding: 0px 20px;
      margin-bottom: 20px;
    }
  }

  .control-block-item {
    cursor: pointer;
    transition: color .1s;

    &:hover {
      color: #008fcc;
    }
  }

  .header-info {
    margin-bottom: 0px;
  }

  .saldo-value {
    position: relative;

    p {
      text-align: right;
      color: #008fcc;
      span {
        color: #C0C4CC;
        font-weight: 300;
      }
      margin: 0;
      margin-right: 20px;
      font-size: 24px;

      @include breakpoint (xs) {
        font-size: 18px;
      }
    }

    span.cents {
      font-size: 14px;
      color: #C0C4CC;
      position: absolute;
      bottom: 3.5px;
      right: 0px;

      @include breakpoint (xs) {
        bottom: 1.5px;
      }
    }

    &.blink {
      animation: blink .3s linear forwards;
      animation-delay: .2s;
    }
  }

  @keyframes blink {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    50% {
      transform: scale(1.2);
      opacity: 0.0;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .el-card {
    margin-bottom: 20px;
    overflow: visible;
  }

  .justify-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/SaldoAndCredit.vue